import { Flex } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { ReactNode } from "react";

type SectionProps = {
  children?: ReactNode;
  color?: "light" | "dark";
  className?: string;
  "data-component"?: string;
  "data-variant"?: string;
};

export const Section = ({
  children,
  color,
  className,
  ...otherProps
}: SectionProps) => {
  const classes = classNames("mobius-quote-card__section", className, {
    "--is-light": color === "light",
    "--is-dark": color === "dark",
  });

  return (
    <div {...otherProps} className={classes}>
      <Flex
        flexDirection="column"
        className="mobius-quote-card__section-container"
      >
        {children}
      </Flex>
    </div>
  );
};
